import React from 'react';
import { NistFunctionPage } from '../../../components/assessment/nist/NistFunctionPage';
import { NIST_FUNCTIONS } from '../../../utils/nistAiRmf';
export function MapFunction() {
  const functionData = NIST_FUNCTIONS.find(f => f.id === 'Map')!;
  return <NistFunctionPage functionId="Map" title={functionData.title} description={functionData.description} nextPath="/assessment/nist/measure" prevPath="/assessment/nist/govern" data-id="element-475" />;
}